import { InputBase } from "@mui/material"

import SearchIcon from '@mui/icons-material/Search';

const CommonTextBox = ({value,onChange,placeholder,startIcon,endIcon}) =>{

    return (
      <InputBase sx={{color:'black',width:'311px',height:'40px',borderRadius:'10px', background:'#F3F3F3', "& input" :{padding:'5px'}}} value={value} onChange={onChange} placeholder={placeholder} startAdornment= {<SearchIcon sx={{'color':'black',px:'5px'}}/>}  />
    )
}

export default CommonTextBox